import React from 'react';
import { Share2, Radio, Sparkles } from 'lucide-react';
import { MARKETING } from '../../mock';

const ICONS = { social: Share2, streaming: Radio, other: Sparkles };

export default function Marketing() {
  return (
    <section id="marketing" className="relative py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="reveal max-w-2xl mb-14">
          <p className="eyebrow mb-4">After the song</p>
          <h2 className="font-display text-5xl md:text-6xl text-cream leading-[0.95]">Then we put it <span className="italic text-gold-grad">to work.</span></h2>
          <p className="mt-5 text-cream/65 text-lg">Want help getting your song heard? Ask from your dashboard and Perry sends you a quote.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {MARKETING.map((m, i) => {
            const Icon = ICONS[m.id];
            return (
              <div key={m.id} className="reveal panel rounded-2xl p-7 hover:border-gold/40 hover:-translate-y-1 transition-all duration-500" style={{ transitionDelay: `${i*80}ms` }}>
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-gold/10 mb-5"><Icon size={20} className="text-gold" /></span>
                <h3 className="font-display text-2xl text-cream mb-3">{m.title}</h3>
                <p className="text-cream/60 leading-relaxed text-[15px]">{m.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
